'use client';

import React, { createContext, useContext, useMemo } from 'react';

export interface PlannerOperatorMaps {
  plannerMap: Map<string, { name: string }>;
  operatorMap: Map<string, { name: string }>;
}

const PlannerOperatorContext = createContext<PlannerOperatorMaps | null>(null);

export function usePlannerOperatorMaps(): PlannerOperatorMaps | null {
  return useContext(PlannerOperatorContext);
}

export interface PlannerOperatorProviderProps {
  plannerMap: Map<string, { name: string }>;
  operatorMap: Map<string, { name: string }>;
  children: React.ReactNode;
}

export function PlannerOperatorProvider({
  plannerMap,
  operatorMap,
  children,
}: PlannerOperatorProviderProps) {
  const value = useMemo(() => ({ plannerMap, operatorMap }), [plannerMap, operatorMap]);
  return (
    <PlannerOperatorContext.Provider value={value}>{children}</PlannerOperatorContext.Provider>
  );
}
